// Beach Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES } from '../config/room-constants.js';

export const stadiumRoom: Room = {
  name: 'Stadium',
  background: '/media/club-penguin/stadium.webp',
  spawn: { x: 341, y: 338 },

  colliders: [...STANDARD_BOUNDARIES],

  hotspots: [
    {
      id: 'stadium-to-ski-village',
      action: 'goto',
      target: 'ski-village',
      spawn: { x: 795, y: 423 },
      x: 448,
      y: 36,
      w: 65,
      h: 72,
    },
    {
      id: 'stadium-to-forest',
      action: 'goto',
      target: 'forest',
      spawn: { x: 335, y: 320 },
      x: 835,
      y: 39,
      w: 63,
      h: 83,
    },
  ],
};
